"use client";

import { useState, useCallback, useEffect } from "react";
import { fetchLeaveRequests } from "@/lib/supabase/leave-actions";
import LeaveListPage from "./LeaveListPage";
import LeaveNewPage from "./LeaveNewPage";
import PageSkeleton from "./PageSkeleton";

type ViewType = "list" | "new";

export default function LeaveShell() {
  const [view, setView] = useState<ViewType>("list");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchLeaveRequests()
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const goToList = useCallback(() => setView("list"), []);
  const goToNew = useCallback(() => setView("new"), []);
  const handleCreated = useCallback(() => {
    goToList();
  }, [goToList]);

  if (loading) return <PageSkeleton name="Leave" />;

  return (
    <>
      {view === "list" && <LeaveListPage onNewRequest={goToNew} />}
      {view === "new" && <LeaveNewPage onBack={goToList} onSuccess={handleCreated} />}
    </>
  );
}
